//src/components/shared/CrudCardActions.tsx
import { KeyRound, Pencil, Power, Trash2 } from "lucide-react";

import { PermissionIconButton } from "@/components/shared/PermissionIconButton";

type CrudCardActionsProps = {
  onPermissions?: () => void;
  onEdit?: () => void;
  onToggleActive?: () => void;
  onDelete?: () => void;
  isActive?: boolean;
  disabled?: boolean;

  permissionsPermission?: string | string[];
  permissionsRequireAll?: boolean;

  editPermission?: string;
  toggleActivePermission?: string;
  deletePermission?: string;

  noPermissionLabel?: string;
};

export function CrudCardActions({
  onPermissions,
  onEdit,
  onToggleActive,
  onDelete,
  isActive = true,
  disabled = false,
  permissionsPermission,
  permissionsRequireAll = false,
  editPermission,
  toggleActivePermission,
  deletePermission,
  noPermissionLabel = "Você não possui permissão para esta ação",
}: CrudCardActionsProps) {
  const permissionsList = Array.isArray(permissionsPermission)
    ? permissionsPermission
    : permissionsPermission
    ? [permissionsPermission]
    : undefined;

  return (
    <div className="flex items-center justify-end gap-1">
      {onPermissions ? (
        <PermissionIconButton
          label="Permissões"
          permissions={permissionsList}
          requireAll={permissionsRequireAll}
          disabled={disabled}
          noPermissionLabel={noPermissionLabel}
          onClick={onPermissions}
        >
          <KeyRound className="h-4 w-4" />
        </PermissionIconButton>
      ) : null}

      {onEdit ? (
        <PermissionIconButton
          label="Editar"
          permission={editPermission}
          disabled={disabled}
          noPermissionLabel={noPermissionLabel}
          onClick={onEdit}
        >
          <Pencil className="h-4 w-4" />
        </PermissionIconButton>
      ) : null}

      {onToggleActive ? (
        <PermissionIconButton
          label={isActive ? "Desativar" : "Ativar"}
          permission={toggleActivePermission}
          disabled={disabled}
          noPermissionLabel={noPermissionLabel}
          onClick={onToggleActive}
          destructive={isActive}
        >
          <Power className="h-4 w-4" />
        </PermissionIconButton>
      ) : null}

      {onDelete ? (
        <PermissionIconButton
          label="Excluir"
          permission={deletePermission}
          disabled={disabled}
          noPermissionLabel={noPermissionLabel}
          onClick={onDelete}
          destructive
        >
          <Trash2 className="h-4 w-4" />
        </PermissionIconButton>
      ) : null}
    </div>
  );
}
